export default __webpack_public_path__ + "static/media/1.5a909a14.jpg";